import { Descriptions } from 'antd'
import dayjs from 'dayjs'
import React from 'react'
import {
  humanizeRefundHistoryDetail,
  REFUND_HISTORY_ACTION_LABEL,
  RefundHistoryAction,
  RefundLedgerRow,
} from '../../../../../types/refund'

type Props = {
  row: RefundLedgerRow
}

const datetime = (value?: string | null) => (value ? dayjs(value).format('YYYY-MM-DD HH:mm') : '-')

/**
 * 상태 전이 이력 — 누가 언제 무엇을 했는지 (aipark-front #266)
 *
 * 대장의 펼친 행과 상세 서랍 양쪽에서 쓴다. 두 곳이 같은 기록을 다르게 보여주면 담당자가
 * 어느 쪽을 믿어야 할지 알 수 없다.
 *
 * 같은 이유로 **행위와 처리 경로를 화면 라벨로 옮긴다.** 서버 이력은 `COMPLETED`·`경로 PORTONE`
 * 처럼 enum 을 그대로 담는데, 대장 칸은 "처리 완료"·"원 결제수단 취소" 라 적는다. 한 건이 두
 * 이름으로 보이면 사후 대조에서 다른 값처럼 읽힌다(화면 구성 v3 S8).
 */
export default function RefundHistory({ row }: Props) {
  return (
    <Descriptions size="small" column={1} bordered>
      {row.history.map((entry) => (
        <Descriptions.Item
          key={`${entry.at}-${entry.action}`}
          label={`${datetime(entry.at)} · ${REFUND_HISTORY_ACTION_LABEL[entry.action as RefundHistoryAction] ?? entry.action}`}
        >
          {entry.actorEmail ?? '-'} · {humanizeRefundHistoryDetail(entry.detail) ?? '-'}
        </Descriptions.Item>
      ))}
      {row.followUpDetail ? <Descriptions.Item label="후속 조치">{row.followUpDetail}</Descriptions.Item> : null}
      {row.memo ? <Descriptions.Item label="메모">{row.memo}</Descriptions.Item> : null}
    </Descriptions>
  )
}
